/**
 * Phase 14 — Mockup: Vehicle-Detail mit BOS-Status-Pille „4 — Am Einsatzort".
 */
export function BosStatusMockup() {
  return (
    <svg
      viewBox="0 0 800 500"
      className="h-auto w-full rounded-xl"
      role="img"
      aria-label="Fahrzeug-Detail mit BOS-Funkstatus 4"
    >
      <rect width="800" height="500" fill="#0a0e1a" />

      {/* Vehicle Detail Panel */}
      <rect x="60" y="40" width="680" height="420" rx="14" fill="#11151f" stroke="#1f2937" />

      {/* Header row */}
      <text x="90" y="84" fill="#ffffff" fontFamily="Inter, sans-serif" fontSize="22" fontWeight="700">
        HLF-1 · Mitte
      </text>
      <text x="90" y="106" fill="#9ca3af" fontSize="12">Hilfeleistungslöschfahrzeug · BF Mitte</text>

      {/* Status pill — large highlight */}
      <rect x="90" y="140" width="220" height="56" rx="28" fill="#dc2626" />
      <circle cx="124" cy="168" r="14" fill="#ffffff" />
      <text x="124" y="174" fill="#dc2626" fontSize="18" fontWeight="800" textAnchor="middle">4</text>
      <text x="148" y="164" fill="#ffffff" fontSize="13" fontWeight="700">Status 4</text>
      <text x="148" y="182" fill="#fecaca" fontSize="11">Am Einsatzort</text>

      {/* Status legend */}
      <text x="90" y="234" fill="#9ca3af" fontSize="11" fontWeight="600" letterSpacing="1.5">
        FUNKSTATI
      </text>
      {[
        { n: 1, label: 'Frei auf Funk', color: '#3b82f6' },
        { n: 2, label: 'Frei auf Wache', color: '#22c55e' },
        { n: 3, label: 'Auf Anfahrt', color: '#3b82f6' },
        { n: 4, label: 'Am Einsatzort', color: '#dc2626' },
        { n: 5, label: 'Sprechwunsch', color: '#a855f7' },
        { n: 6, label: 'Nicht einsatzbereit', color: '#64748b' },
        { n: 7, label: 'Patient an Bord', color: '#f59e0b' },
        { n: 8, label: 'Übergabe Klinik', color: '#a855f7' },
      ].map((s, i) => {
        const x = 90 + (i % 4) * 156;
        const y = 250 + Math.floor(i / 4) * 80;
        const active = s.n === 4;
        return (
          <g key={s.n}>
            <rect
              x={x}
              y={y}
              width="140"
              height="60"
              rx="10"
              fill={active ? s.color : '#0b101b'}
              stroke={active ? s.color : '#1f2937'}
              opacity={active ? 1 : 0.95}
            />
            <text
              x={x + 16}
              y={y + 28}
              fill={active ? '#ffffff' : s.color}
              fontSize="22"
              fontWeight="800"
            >
              {s.n}
            </text>
            <text
              x={x + 44}
              y={y + 24}
              fill={active ? '#ffffff' : '#e5e7eb'}
              fontSize="11"
              fontWeight="600"
            >
              Status {s.n}
            </text>
            <text
              x={x + 44}
              y={y + 42}
              fill={active ? '#fee2e2' : '#9ca3af'}
              fontSize="10"
            >
              {s.label}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
